import { loadBoostedGifs, setBoostedGifs } from "utils/storage";

const MS_IN_SECONDS = 1000;
const HOUR_IN_SECONDS = 3600;

export class BoostHistory {
  private boostGifs: any = {};

  public constructor() {
    this.boostGifs = loadBoostedGifs() || {};
  }

  public add(gifId: string, ttl: number): void {
    const currentTime = new Date().getTime() / MS_IN_SECONDS;

    this.boostGifs[gifId] = currentTime + (HOUR_IN_SECONDS * ttl);

    setBoostedGifs(this.boostGifs);
  }

  public getCurrent(): string[] {
    const res: string[] = [];
    const currentTime = new Date().getTime() / MS_IN_SECONDS;

    for (const key in this.boostGifs) {
      if (currentTime < this.boostGifs[key]) {
        res.push(key);
      }
    }

    return res;
  }

  public reset(): void {
    this.boostGifs = {};
    setBoostedGifs(this.boostGifs);
  }
}

export const boostHistory = new BoostHistory();
